.bi{flex-shrink:0;}